'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:ActivityDetailsController
 * @description
 * # ActivityDetailsController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('ActivityDetailsController', ['$scope', '$location', 'TALocationService', 'TodaysAssignments', 'Constants',
      function ($scope, $location, TALocationService, TodaysAssignments, Constants) {

      $scope.todaysAssignments = new TodaysAssignments(null, Constants.TodaysAssignments.Levels.ActivityDetails);

      $scope.save = function () {
          $scope.todaysAssignments.SaveActivity();
      };

      $scope.cancel = function () {
          $scope.todaysAssignments.CancelActivity();
          $scope.back();
      };

      $scope.back = function () {
          var activityInfo = $scope.todaysAssignments.activityData;

          if (activityInfo && activityInfo.facilityCode && activityInfo.roomNumber) {

              TALocationService.GoToTheRoomGroups(activityInfo.facilityCode, activityInfo.roomNumber);
          } else {
              TALocationService.GoToTheHomePage();
          }
      };

      $scope.openPreparationList = function () {
          $scope.todaysAssignments.dataLoaded = false;
          TALocationService.GoToThePreparationList();
      };

      function init() {
          $scope.todaysAssignments.LoadActivityData();
      }

      init();
      
      $scope.$on('$destroy', function () {
          $scope.todaysAssignments.closeSignalRConnection();
      });
  }]);
